import React from 'react';
import ButtonToolbar from 'react-bootstrap/ButtonToolbar';
import { LinkContainer } from 'react-router-bootstrap';
import { Link, useLocation } from 'react-router-dom';

export default function GuestNavbarContent() {
  const location = useLocation();
  const isLoggingIn = location.pathname === '/login';
  return (
    <>
      <ButtonToolbar className="custom-btn-toolbar mr-auto">
        <LinkContainer className="mr-4" to="/">
          <img
            className="logo"
            src="/HADI-logo.png"
            alt="HADI - Headache Data Insight"
            width="140"
            height="90"
          ></img>
        </LinkContainer>
      </ButtonToolbar>
      {isLoggingIn ? (
        <Link to="/">
          <button className="btn btn-danger">Cancel</button>
        </Link>
      ) : (
        <Link to="/login">
          <button className="btn btn-primary">Log In</button>
        </Link>
      )}
    </>
  );
}
